/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/layout_card'
export default icon
